
import React from "react";
import { Button } from "@/components/ui/button";
import { useLeadCapture } from "@/hooks/useLeadCapture";

const TocFotosHero = () => {
  const { openLeadCapture, LeadCaptureModalComponent } = useLeadCapture({
    title: "Solicitar orçamento",
    description: "Preencha seus dados para receber seu orçamento",
    source: "TocFotos Hero"
  });

  return (
    <>
      {LeadCaptureModalComponent}
      <section className="relative pt-16 pb-24 md:pt-24 md:pb-32">
        <div className="absolute inset-0 w-full h-full z-0">
          <div className="absolute inset-0 bg-cover bg-center" style={{
            backgroundImage: "url('https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d')"
          }} />
          <div className="absolute inset-0 bg-white/70" />
        </div>
        
        <div className="container max-w-7xl mx-auto px-4 text-center relative z-10">
          <div className="mb-12">
            
          </div>
          
          <div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-semibold text-[#FF5605] mb-6">
              Simples, rápido e eficiente.
            </h1>
            
            <p className="text-xl md:text-2xl text-[#261E13]/80 max-w-3xl mx-auto mb-12">
              Fotografia profissional que destaca o verdadeiro potencial do seu imóvel
            </p>
            
            <Button onClick={() => openLeadCapture()} size="lg" className="bg-[#FF5605] hover:bg-[#E14D04] text-white rounded-full px-8 py-7 text-lg font-medium">
              Solicitar Orçamento
            </Button>
          </div>
        </div>
      </section>
    </>
  );
};

export default TocFotosHero;
